import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContratoListarComponent } from './contrato-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ContratoListarComponent }
    ])],
    exports: [RouterModule]
})
export class ContratoListarRoutingModule { }
